module.exports = __webpack_public_path__ + "img/fig.0fbb0944.png";